module.exports = __webpack_public_path__ + "img/6387a8d53834b0a430eeadf2c4b95d3.d9c1236e.png";